import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { CandidateSearchGridComponent } from 'src/app/recruiting/candidates/candidate-search/components/candidate-search-grid/candidate-search-grid.component';
import { State } from 'src/app/recruiting/candidates/candidate-search/models/state.model';
import { UntypedFormControl } from '@angular/forms';
import { CandidateSearchService } from '../../candidate-search.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'nova-candidate-search-modal',
    templateUrl: './candidate-search-modal.component.html',
    styleUrls: ['./candidate-search-modal.component.scss']
})
export class CandidateSearchModalComponent implements AfterViewInit {
    private readonly _title = 'Find a Candidate';

    get count(): number {
        return this.grid.count;
    }

    get title(): string {
        return this.state === State.succeed ? `Results (${this.count})` : this._title;
    }

    get isInitial(): boolean {
        return this.state === State.initial;
    }

    get isLoading(): boolean {
        return this.state === State.loading;
    }

    get isSucceed(): boolean {
        return this.state === State.succeed;
    }

    get hasNoResults(): boolean {
        return this.state === State.noResults;
    }

    searchText = new UntypedFormControl('');

    @ViewChild(CandidateSearchGridComponent, { static: false }) grid: CandidateSearchGridComponent;

    private state: State = State.initial;

    constructor(private readonly _candidateSearchService: CandidateSearchService) {}

    ngAfterViewInit() {
        this.grid.isLoading$.pipe(untilDestroyed(this)).subscribe((isLoading) => {
            if (this.isInitial) {
                return;
            }

            if (!isLoading) {
                this.state = this.grid.count ? State.succeed : State.noResults;
            }
        });
    }

    searchCandidates(searchText: string) {
        if (this.isLoading) {
            return;
        }

        if (!searchText || searchText.trim().length < 3) {
            return;
        }

        const filter = this._candidateSearchService.createFilter(searchText);
        if (!filter) {
            this.state = State.noResults;
        } else {
            this.grid.quickSearchCandidates(filter);
            this.state = State.loading;
        }
    }
}
